import { useState } from 'react';
import { rankWith, uiTypeIs, LayoutProps } from '@jsonforms/core';
import {
  ResolvedJsonFormsDispatch,
  withJsonFormsLayoutProps,
} from '@jsonforms/react';

import {
  getElements,
  getLabel,
  getRule,
} from '../../../../../utils/DynamicForms';

import './style.scss';

type Props = LayoutProps; // use correct prop type

const HorizontalFields = (props: Props) => {
  const elements = getElements(props.uischema).filter((element) => {
    //TODO:need to  deal with the rules on the tab itself to render the button and the tab-content based on the rule
    const rule = getRule(element);
    if (!rule) return true;

    const ruleEnum = rule.condition.schema?.enum;
    if (!ruleEnum) return true;

    // rule.effect === 'SHOW'
    const key = rule.condition.scope.split('#/properties/')?.[1];
    const values = props.data[key] as string[];

    return !!ruleEnum.find((value) => values.includes(value));
  });
  const classes = props.uischema?.options?.classes
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [active, setActive] = useState(getLabel(elements[0]));

  return (
    <div className={`tru-layout-horizontal-fields ${classes}`}>
      {elements.map((element, i) => (
        <div
          className={`field-content ${active === getLabel(element) ? 'visible' : 'hidden'
            }`}
          key={`field-content-${i}`}
        >
          <ResolvedJsonFormsDispatch {...props} uischema={element} />
        </div>
      ))}
    </div>
  );
};

export const HorizontalFieldsEntry = {
  tester: rankWith(1, uiTypeIs('HorizontalFields')),
  renderer: withJsonFormsLayoutProps(HorizontalFields),
};
